// extracted by mini-css-extract-plugin
export default {"header":"YRkxy2XzKthJmIy3fxDw","licenseList":"aV42ld0vTp2BbJh5O78M","inputGroup":"DFG24buwVoyR0DLMLVW5"};